<template>
  <div class="gift-today">
    <div class="gift-today-head">
      <h2 class="gift-today-title">{{ title }}</h2>
      <div class="gift-day">
        <label for="gift-day">Ver otro día</label>
        <input
          id="gift-day"
          type="date"
          class="gift-input gift-day-input"
          :value="date"
          :max="today"
          :disabled="loading"
          @change="chooseDay"
        />
      </div>
    </div>

    <p v-if="date" class="gift-count">{{ countLine }}</p>

    <p v-if="loading && !rows.length" class="gift-empty">Cargando…</p>
    <p v-else-if="!rows.length" class="gift-empty">No se canjeó ningún regalo ese día.</p>

    <div v-if="rows.length" class="gift-tscroll">
      <table class="gift-table">
        <thead>
          <tr>
            <th>Hora</th>
            <th>Código</th>
            <th>Regalo</th>
            <th>Campaña</th>
            <th>Boleta</th>
            <th>Se devuelve</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in rows" :key="row.formatted_code">
            <td>{{ onlyTime(row.redeemed_at) }}</td>
            <td class="gift-code-cell">{{ row.formatted_code }}</td>
            <td>{{ row.delivered_meal }}</td>
            <td>{{ row.campaign_name }}</td>
            <td>S/{{ toSoles(row.purchase_amount_cents) }}</td>
            <td>S/{{ toSoles(row.refund_amount_cents) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <base-pagination
      v-if="hasPages"
      class="gift-pages"
      align="center"
      :value="page"
      :per-page="perPage"
      :total="total"
      @input="goToPage"
    ></base-pagination>
  </div>
</template>

<script>
import GiftCodesGateway from '../../gateways/GiftCodesGateway'

const CENTS_PER_SOL = 100
const DECIMALS = 2
const TIME_START = 11
const TIME_LENGTH = 5
const FIRST_PAGE = 1
const NO_PAGE_SIZE = 0
const DAY_PARTS = 3
const ONE = 1

export default {
  name: 'RedemptionsOfDay',
  data () {
    return {
      date: '',
      today: '',
      page: FIRST_PAGE,
      perPage: NO_PAGE_SIZE,
      total: NO_PAGE_SIZE,
      refundTotalCents: NO_PAGE_SIZE,
      hasPages: false,
      rows: [],
      loading: false,
      lastRequest: NO_PAGE_SIZE
    }
  },
  computed: {
    countLine () {
      const canjes = this.total + (this.total === ONE ? ' canje' : ' canjes')
      return this.total ? canjes + ' · S/' + this.toSoles(this.refundTotalCents) + ' para devolver' : canjes
    },
    title () {
      if (!this.date || this.date === this.today) {
        return 'Canjeados hoy en esta tienda'
      }
      return 'Canjeados el ' + this.spanishDate(this.date) + ' en esta tienda'
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    toSoles (cents) {
      return ((cents || 0) / CENTS_PER_SOL).toFixed(DECIMALS)
    },
    onlyTime (dateTime) {
      return (dateTime || '').substr(TIME_START, TIME_LENGTH)
    },
    spanishDate (isoDate) {
      const parts = String(isoDate).split('-')
      return parts.length === DAY_PARTS ? parts.reverse().join('/') : isoDate
    },
    chooseDay (event) {
      this.date = event.target.value
      this.page = FIRST_PAGE
      this.load()
    },
    goToPage (page) {
      if (page === this.page) {
        return
      }
      this.page = page
      this.load()
    },
    reloadToday () {
      this.date = this.today
      this.page = FIRST_PAGE
      this.load()
    },
    load () {
      this.loading = true
      this.lastRequest += 1
      const request = this.lastRequest

      GiftCodesGateway.redemptions(this.date, this.page)
        .then(response => {
          if (request !== this.lastRequest) {
            return
          }
          this.apply(response.data.payload.results)
        })
        .catch(() => {
          if (request === this.lastRequest) {
            this.clear()
          }
        })
        .then(() => {
          if (request === this.lastRequest) {
            this.loading = false
          }
        })
    },
    clear () {
      this.rows = []
      this.total = NO_PAGE_SIZE
      this.refundTotalCents = NO_PAGE_SIZE
      this.hasPages = false
    },
    apply (results) {
      this.date = results.date
      this.today = results.today
      this.page = results.page
      this.perPage = results.per_page
      this.total = results.total
      this.refundTotalCents = results.refund_total_cents
      this.hasPages = results.has_pages === true
      this.rows = results.redemptions
    }
  }
}
</script>

<style scoped>
.gift-today { margin-top: 26px; color: #1a2420; font-size: 15px; }
.gift-today-head { display: flex; align-items: flex-end; justify-content: space-between; gap: 16px; flex-wrap: wrap; margin-bottom: 6px; }
.gift-today-title { font-size: 15px; font-weight: 660; margin: 0; }
.gift-day label { font-size: 11px; font-weight: 650; text-transform: uppercase; letter-spacing: .06em; color: #8a988f; display: block; margin-bottom: 6px; }
.gift-input { box-sizing: border-box; background: #f0f4f1; border: 1.5px solid #e2e8e3; color: #1a2420; font: inherit; font-weight: 600; padding: 8px 12px; border-radius: 10px; }
.gift-input:focus { outline: none; border-color: #5DBC85; }
.gift-day-input { cursor: pointer; }
.gift-count { margin: 0 0 10px; font-size: 13px; font-weight: 600; color: #5c6b63; }
.gift-empty { color: #5c6b63; font-size: 13px; }
.gift-tscroll { overflow-x: auto; }
.gift-table { border-collapse: collapse; width: 100%; font-size: 14px; }
.gift-table th { text-align: left; font-size: 11px; font-weight: 660; text-transform: uppercase; letter-spacing: .04em; color: #8a988f; padding: 10px 14px; border-bottom: 1.5px solid #e2e8e3; white-space: nowrap; }
.gift-table td { padding: 10px 14px; border-bottom: 1px solid #e2e8e3; font-variant-numeric: tabular-nums; }
.gift-code-cell { font-family: monospace; font-weight: 600; }
.gift-pages { margin-top: 14px; }
.gift-pages >>> .page-item.active .page-link { background: #5DBC85; border-color: #5DBC85; box-shadow: none; }
.gift-pages >>> .page-link { color: #5c6b63; }
.gift-pages >>> .page-item.active .page-link { color: #fff; }
</style>
